export default "__VITE_ASSET__54647c91__"